let state = {
  //Boards with columns and tasks
  taskBoards: [],
};

export default state;
